import { ADeleteButton } from "@/admin/ADeleteButton.tsx";
import { AdminList } from "@/admin/AdminList.tsx";
import { AdminTable } from "@/admin/AdminTable.tsx";
import { AEditButton } from "@/admin/AEditButton.tsx";
import { specFields } from "@/admin/metal/specs/specFields.tsx";
import { SpecItemModal } from "@/admin/metal/specs/SpecItemModal.tsx";
import { specDeleteMutation, specLocationQueryAtom } from "@/admin/metal/specs/specQuery.ts";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { useLocationsForType } from "@/modules/location/locationQuery.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export function SpecsView() {
    return (
        <AdminList entityType="spec" addModal={<SpecItemModal />}>
            <AdminSpecsTable />
        </AdminList>
    );
}

function AdminSpecsTable() {
    const locations = useLocationsForType("bare_metal");
    const specs = useSuspenseQueryAtom(specLocationQueryAtom(locations.defaultLocation));
    const deleteMutation = useStandardMutation(specDeleteMutation);

    return (
        <AdminTable
            items={[...specs.values()]}
            fields={specFields}
            getId={(e) => e.uuid}
            actionButtons={(item) => (
                <>
                    <WModal button={<AEditButton />}>
                        <SpecItemModal item={item} />
                    </WModal>
                    <ADeleteButton entityType="spec" deleteFn={async () => await deleteMutation.mutateAsync(item)} />
                </>
            )}
        />
    );
}
